import axios from "axios";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import { TTProtection } from "../TTProtection";
import { ttProtectionUrls } from "../../../URL/ApplicationUrls";
import { namedQueryKeyWithId } from "../../../ReactQuery/namedQueryKeyWithId";

export const useUpdateTTProtectionWithoutVersion = (
  ttProtectionId: number | string | undefined
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (ttProtection: TTProtection) => {
      return axios.put(ttProtectionUrls.apiDetailsFor(ttProtection.Id), ttProtection);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries(namedQueryKeyWithId("ttProtections", ttProtectionId));
      toast.success(`Updating the TT Protection with the P-Nr. ${ttProtectionId} was successful`);
    },
    onError: () => {
      toast.error(`An error occurred when updating the TT Protection with P-Nr. ${ttProtectionId}`);
    },
  });
};
